import { render, staticRenderFns } from "./ClientesWeb.vue?vue&type=template&id=0fa9b733&lang=pug"
import script from "./ClientesWeb.vue?vue&type=script&lang=js"
export * from "./ClientesWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports